import React from 'react'
import Page from '../components/containers/Page'
import ButtonUI from '../components/common/ButtonUI'
import { project } from '../data/data'

const Careers = () => {

  document.title = `CARRIERES — ${project.website}`

  return (
    <Page offset>
      <div className='resp flex flex-col min-h-[60svh] justify-center'>
     {/*    <h1>Careers</h1>
        <p className='muted'>No listings for now.</p> */}

        <div className='flex flex-col my-40 gap-4'>
          <h2 className='max-w-[40ch] text-left text-pretty'>
            Thank you for checking our Careers listing.<br /> <span className='dim muted'>We have no openings as of now.</span>
          </h2>
          <ButtonUI variant={"naked"}>Subscribe to the Careers alert</ButtonUI>
        </div>

      </div>
    </Page>
  )
}

export default Careers